export default function (instance) {
  return {
    getSchedule(date) {
      return instance.get(`/facility_visits/${date}`);
    },
    createRecord(payload) {
      return instance.post("/facility_visits/create", payload);
    },
    patchRecord(visitId, payload) {
      return instance.put(`/facility_visits/?visit_id=${visitId}`, payload);
    },
  };
}
